var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{staticClass:"text-center pt-15"},[_c('v-col',[_c('div',{staticClass:"text-body-1 mt-10 mb-10"},[_vm._v(" "+_vm._s(_vm.$t('page404.pageNotFound'))+" ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }